import LinearProgress from "@mui/material/LinearProgress";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Toast } from "shared";
import { TeamItem } from "entitites/teams/ui";
import {
  useGetAllTeamsQuery,
  useLazyGetAllTeamsBySearchStringQuery,
} from "entitites/teams/api/teamsApi";

const listItemSize = 52;

export const TeamPageList = () => {
  const [cursor, setCursor] = useState("");
  const { search } = useLocation();
  const [params] = useSearchParams();
  const isSearch = Boolean(
    params.get("status") ||
      params.get("text") ||
      params.get("position") ||
      params.get("statusS4S")
  );
  const {
    data: posts,
    error,
    isLoading,
    isUninitialized,
    isError,
    isFetching,
  } = useGetAllTeamsQuery(`${cursor}`);

  const [getEmployees, data] = useLazyGetAllTeamsBySearchStringQuery();

  useEffect(() => {
    isSearch && getEmployees(`${search}`);
  }, [getEmployees, search, isSearch]);

  if (isLoading || isUninitialized || data.isLoading || data.isFetching) {
    return <LinearProgress sx={{ mt: -0.25, ml: -0.25 }} />;
  }

  if (isError) {
    return <Toast error={JSON.stringify(error)} />;
  }

  if (!posts.length) {
    return (
      <Box p={3} py={1}>
        Нет данных
      </Box>
    );
  }

  return (
    <AutoSizer>
      {({ height, width }: { width: number; height: number }) => (
        <>
          {isFetching && (
            <LinearProgress
              sx={{
                width: width,
                mt: -0.25,
                ml: -0.25,
                position: "absolute",
                bottom: 0,
              }}
            />
          )}
          {isSearch ? (
            <FixedSizeList
              itemData={data.data || []}
              height={height}
              width={width}
              itemSize={listItemSize}
              itemCount={data.data?.length || 0}
              overscanCount={20}
            >
              {({ index, style, data }) =>
                data[index] && (
                  <TeamItem style={style} data={data[index]} width={width} />
                )
              }
            </FixedSizeList>
          ) : (
            <FixedSizeList
              onScroll={({ scrollOffset, scrollDirection }) => {
                if (scrollDirection === "forward") {
                  const itemCount = posts.length;
                  const endIndex = Math.min(
                    itemCount - 1,
                    Math.floor((scrollOffset + height + 1500) / listItemSize)
                  );
                  if (
                    endIndex === itemCount - 1 &&
                    !isFetching &&
                    cursor !== posts[posts.length - 1].id
                  ) {
                    setCursor(posts[posts.length - 1].id);
                  }
                }
              }}
              itemData={posts}
              height={height}
              width={width}
              itemSize={listItemSize}
              itemCount={posts.length}
              overscanCount={20}
            >
              {({ index, style, data }) =>
                data[index] && (
                  <TeamItem style={style} data={data[index]} width={width} />
                )
              }
            </FixedSizeList>
          )}
        </>
      )}
    </AutoSizer>
  );
};
